import { render, staticRenderFns } from "./SidSelect.vue?vue&type=template&id=ac936d04"
import script from "./SidSelect.vue?vue&type=script&lang=js"
export * from "./SidSelect.vue?vue&type=script&lang=js"
import style0 from "./SidSelect.vue?vue&type=style&index=0&id=ac936d04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports